import React from 'react';
import IconButton from 'fe-design-base/molecules/IconButton';

import Popover from 'components/Popover';

import { cxHelpers } from 'util/className';
import { toI18n } from 'util/i18n';

import MenuOptions from '../../MenuOptions';
import { MENU_STYLE, MENU_STYLE_SCRIM_OPENED } from '../constants';
const { cxEl } = cxHelpers('MessengerView');

const MessengerHeaderMenu = ({
  repackagingEnabled,
  showMessengerScrim,
  menuOpen,
  handleMenuClose,
  toggleMenuOpen,
}) => (
  <Popover
    body={<MenuOptions repackagingEnabled={repackagingEnabled} />}
    isOpen={menuOpen}
    onOuterAction={handleMenuClose}
    preferPlace="below"
    theme="white"
    style={showMessengerScrim ? MENU_STYLE_SCRIM_OPENED : MENU_STYLE}
  >
    <IconButton
      icon="MoreVertical"
      color="primary700"
      className={cxEl('edit-menu')}
      size="medium"
      onClick={toggleMenuOpen}
      label={toI18n('messaging.actions.more_options')}
    />
  </Popover>
);

export default MessengerHeaderMenu;
